import type { Meta, StoryObj } from '@storybook/angular';
import { expect } from 'storybook/test';
import { CheckMarkerIconComponent } from '../../../app/core/svg-icons/check-marker-icon.component';

const meta: Meta<CheckMarkerIconComponent> = {
  title: 'Atoms/Icons/CheckMarkerIcon',
  component: CheckMarkerIconComponent,
  parameters: {
    docs: {
      description: {
        component: 'A check marker icon component perfect for indicating completed states, success messages, or selections.',
      },
    },
  },
};

export default meta;
type Story = StoryObj<CheckMarkerIconComponent>;

export const Default: Story = {
  render: () => ({
    template: '<app-check-marker-icon></app-check-marker-icon>',
  }),
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-check-marker-icon')).toBeTruthy();
  },
};

export const InSuccessMessage: Story = {
  render: () => ({
    template: `
      <div style="display: flex; align-items: center; gap: 0.5rem; background-color: #D4EDDA; color: #155724; padding: 1rem; border-radius: 4px;">
        <app-check-marker-icon></app-check-marker-icon>
        <span>Order completed successfully!</span>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Check marker icon used in a success message context.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-check-marker-icon')).toBeTruthy();
  },
};

export const InList: Story = {
  render: () => ({
    template: `
      <ul style="list-style: none; padding: 0; margin: 0;">
        <li style="display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0;">
          <app-check-marker-icon></app-check-marker-icon>
          <span>Free shipping on orders over €75</span>
        </li>
        <li style="display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0;">
          <app-check-marker-icon></app-check-marker-icon>
          <span>30-day return policy</span>
        </li>
        <li style="display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0;">
          <app-check-marker-icon></app-check-marker-icon>
          <span>Expert wine curation</span>
        </li>
        <li style="display: flex; align-items: center; gap: 0.5rem; padding: 0.5rem 0;">
          <app-check-marker-icon></app-check-marker-icon>
          <span>Secure payment</span>
        </li>
      </ul>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Check marker icons used in a feature list or benefits list.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-check-marker-icon')).toBeTruthy();
  },
};

export const OnDarkBackground: Story = {
  render: () => ({
    template: `
      <div style="background-color: #5C0A31; color: white; padding: 2rem; border-radius: 8px;">
        <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 1rem;">
          <app-check-marker-icon></app-check-marker-icon>
          <span>Premium wine selection</span>
        </div>
        <div style="display: flex; align-items: center; gap: 0.5rem;">
          <app-check-marker-icon></app-check-marker-icon>
          <span>Expert sommelier recommendations</span>
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Check marker icon on a dark wine-colored background.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-check-marker-icon')).toBeTruthy();
  },
};

export const MultipleUses: Story = {
  render: () => ({
    template: `
      <div style="display: grid; grid-template-columns: 1fr 1fr; gap: 2rem;">
        <div>
          <h4>Checklist</h4>
          <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
            <app-check-marker-icon></app-check-marker-icon>
            <span>Item completed</span>
          </div>
          <div style="display: flex; align-items: center; gap: 0.5rem; margin-bottom: 0.5rem;">
            <app-check-marker-icon></app-check-marker-icon>
            <span>Another task done</span>
          </div>
        </div>
        <div>
          <h4>Success Badge</h4>
          <div style="display: inline-flex; align-items: center; gap: 0.5rem; background-color: #28A745; color: white; padding: 0.5rem 1rem; border-radius: 20px;">
            <app-check-marker-icon></app-check-marker-icon>
            <span>Verified</span>
          </div>
        </div>
      </div>
    `,
  }),
  parameters: {
    docs: {
      description: {
        story: 'Various use cases for the check marker icon.',
      },
    },
  },
  play: async ({ canvasElement }) => {
    await expect(canvasElement.querySelector('app-check-marker-icon')).toBeTruthy();
  },
};
